import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  updateStatus = new BehaviorSubject<boolean>(false);

  constructor() { }
}
